import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { BaseBasicDialog } from '@appshared';

@Component({
  selector: 'app-contact-it-dialog',
  templateUrl: './contact-it-dialog.component.html',
  styleUrls: ['./contact-it-dialog.component.scss'],
})
export class ContactITDialogComponent extends BaseBasicDialog {
  reason: string;

  constructor(
    public dialogRef: MatDialogRef<ContactITDialogComponent>,
    protected _fuseTranslationLoaderService: FuseTranslationLoaderService,
    protected _fuseProgressBarService: FuseProgressBarService
  ) {
    super(dialogRef, _fuseTranslationLoaderService, _fuseProgressBarService);
  }
}
